import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import Drivers from "../../components/Drivers/Drivers"; // Виправив шлях на правильний
import BlockTitle from "../../components/Common/BlockTitle"; // Виправив шлях на правильний
import PageHeading from "../../components/Common/PageHeading";
import { useDriversContext } from "../../contexts/drivers"; // змінив відносний шлях
import IracingLogo from "../../assets/IracingLogo.jpg"; // змінив відносний шлях
import F1Logo from "../../assets/F1iconsquare.png";
import styled, { css } from "styled-components";

const Disclamer = styled.div`
  opacity: 0.2;
  font-size: 16px;
  text-align: center;
  font-family: "Montserrat", sans-serif;
  padding-top: 24px;
`;

const DriversPage = () => {
  const { loadDrivers } = useDriversContext();
  const [searchParams, setSearchParams] = useSearchParams();
  const initialSimulator = searchParams.get("simulator") || "iRacing";
  const [simulator, setSimulator] = useState(initialSimulator);

  const handleSimulatorChange = (sim) => {
    if (simulator === sim) return;
    setSimulator(sim);
    setSearchParams({ simulator: sim });
  };

  const GameSelectorContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 16px;
    align-items: center;
  `;

  const SimButton = styled.button`
    background: none;
    outline: none;
    border: none;
    display: flex;
    flex-direction: row;
    align-items: center;
    color: white;
    gap: 4px;
    font-family: "Montserrat", sans-serif;
    cursor: pointer;
    border: 1px solid transparent;
    padding: 8px;
    font-size: 14px;
    font-weight: 400;

    ${(props) =>
      props.active &&
      css`
        border: 1px solid #aeff00;
        background: #aeff0017;
        border-radius: 4px;
      `}
    ${(props) =>
      props.disabled &&
      css`
        cursor: not-allowed;
        opacity: 0.5;
      `}
  `;

  const SimulatorImg = styled.img`
    object-fit: cover;
    width: 16px;
    height: 16px;
  `;

  useEffect(() => {
    loadDrivers(simulator);
  }, [simulator, loadDrivers]);

  return (
    <div style={{ marginTop: 24 }}>
      <BlockTitle>
        <PageHeading>Пілоти</PageHeading>
        <GameSelectorContainer>
          <SimButton
            onClick={() => handleSimulatorChange("iRacing")}
            active={simulator === "iRacing"}
          >
            <SimulatorImg src={IracingLogo} />
            iRacing
          </SimButton>
          <SimButton onClick={() => handleSimulatorChange("EA F1")} active={simulator === "EA F1"}>
            <SimulatorImg src={F1Logo} />
            EA F1
          </SimButton>
        </GameSelectorContainer>
      </BlockTitle>
      <Drivers simulator={simulator} />

      <Disclamer>Наберіть 20+ очок, щоб з’явитися серед пілотів ліги.</Disclamer>
    </div>
  );
};

export default DriversPage;
